export const remCalc = (px, base = 16) => {
  const rem =  Math.round(((px / base) + Number.EPSILON) * 100) / 100;
  return `${rem}rem`;
}